import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {AUTH_TOKEN, COMPANY_NAME, USER_ID} from "constants/AuthConstant";
import FirebaseService from "services/FirebaseService";
import AuthService from "services/AuthService";
import { setAuthStatus } from "./roleSlice";
import { updateCurrency } from "./analyticsSlice";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import { setFirstTimeUser } from "utils/firstTimeUser";
import { handleScopeAddition } from "utils/Scope";

export const initialState = {
    loading: false,
    message: "",
    showMessage: false,
    redirect: "",
    token: localStorage.getItem(AUTH_TOKEN) || null,
};

export const signIn = createAsyncThunk(
    "auth/login",
    async (data, {rejectWithValue, dispatch}) => {
        const {email, password} = data;
        try {
            const response = await AuthService.login({email, password});
            // console.log("saurav res received = ", response);
            const token = response?.user?.token;
            const user_id = response?.user?.user_id;
            const company_name = response?.user.company_name
            const webSite = response?.user?.website
            const user_name= response?.user?.user_name;
            const company_id = response?.user?.company_id
            const scope= response?.user?.scopes;
            const x_request_source= response?.user["x-request-source"];
            const role_id= response?.user?.role_id;
            handleScopeAddition(x_request_source,scope);
            if(response?.user?.currency){
                dispatch(updateCurrency(response?.user?.currency));
            }
            localStorage.setItem(AUTH_TOKEN, token);
            localStorage.setItem(USER_ID, user_id)
            localStorage.setItem(COMPANY_NAME, company_name)
            localStorage.setItem('website', webSite);
            localStorage.setItem('companyId', company_id);
            localStorage.setItem("user_name",user_name);
            localStorage.setItem("roleId",role_id);
            dispatch(setAuthStatus(response?.user?.role_id));
            if(localStorage.getItem("shop_domain")){
                window.open(`${APP_PREFIX_PATH}/shopify/plans`,"_self");
            }
            const params= new URLSearchParams(window.location.search);
            if(params.has("token")&&params.has("onboarded")){
                if(params.get("onboarded")=="influencer"){
                    window.open(`${APP_PREFIX_PATH}/live-call/stream/schedule?token=${params.get("token")}&onboarded=influencer`,"_self");
                }
                if(params.get("onboarded")=="aggregator"){
                    window.open(`${APP_PREFIX_PATH}/dashboards/default?token=${params.get("token")}&onboarded=aggregator`,"_self");
                }
            }
            return token;
        } catch (err) {
            console.log("not in catch", err);
            return rejectWithValue(err.response?.data?.message || "Error");
        }
    }
);

export const signUp = createAsyncThunk(
    "auth/register",
    async (data, {rejectWithValue, dispatch}) => {
        const {first_name, last_name, email, password, confirm_password, mobile_no, company_name, currency, website,shop_domain,license_token, purpose,org_id} = data;
        const proccessedData = {
            email,
            password,
            confirm_password,
            first_name,
            last_name,
            mobile_no,
            company_name,
            currency,
            website,
            shop_domain,
            license_token,
            purpose,
            org_id
            // url,
            // available_date_range: "365 days",
            // available_time_range: "1 min",
        };
        try {
            const response = await AuthService.register(proccessedData,shop_domain?true:false,license_token?true:false);
            // const token = response.data.token;
            //   localStorage.setItem(AUTH_TOKEN, token);
            const website = response?.user?.website;
            const company_id = response?.user?.company_id;
            localStorage.setItem('website',website);
            localStorage.setItem('companyId', company_id);
            dispatch(signIn({ email, password }));
            return response.message;
        } catch (err) {
            console.log("error = ", err);
            return rejectWithValue(err?.response?.data?.message || "Error");
        }
    }
);

export const signOut = createAsyncThunk("auth/logout", async () => {
    const response = await FirebaseService.signOutRequest();
    localStorage.removeItem(AUTH_TOKEN);
    localStorage.removeItem(USER_ID);
    localStorage.removeItem(COMPANY_NAME);
    localStorage.removeItem('website');
    localStorage.removeItem('companyId');
    localStorage.removeItem('roleId');
    localStorage.removeItem('timezone');
    localStorage.removeItem('currencyKey');
    localStorage.removeItem('email');
    localStorage.removeItem('influencerCompanyName');
    localStorage.removeItem('influencerCompanyId');
    localStorage.removeItem('aggregatorCompanyId');
    localStorage.removeItem('aggregatorCompnayName');
    localStorage.removeItem("user_name")
    localStorage.removeItem('scope');
    localStorage.removeItem('shop_domain');
    localStorage.removeItem('x_request_source');
    localStorage.removeItem("store_name");
    localStorage.removeItem("store_front_access_token");

    setFirstTimeUser(false);
    return response.data;
});

export const signInWithGoogle = createAsyncThunk(
    "auth/signInWithGoogle",
    async (_, {rejectWithValue}) => {
        try {
            const response = await AuthService.loginInOAuth();
            const token = response.data.token;
            localStorage.setItem(AUTH_TOKEN, token);
            return token;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || "Error");
        }
    }
);

export const signInWithFacebook = createAsyncThunk(
    "auth/signInWithFacebook",
    async (_, {rejectWithValue}) => {
        try {
            const response = await AuthService.loginInOAuth();
            const token = response.data.token;
            localStorage.setItem(AUTH_TOKEN, token);
            return token;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || "Error");
        }
    }
);

export const signInwithSSO = createAsyncThunk(
    "auth/sso",
    async (data, {rejectWithValue, dispatch}) => {
        try {
            const response = await AuthService.ssoAuthentication(data);
            const token = response?.data?.token;
            const user_id = response?.data?.user_id;
            const company_name = response?.data.company_name
            const webSite = response?.data?.website
            const company_id = response?.data?.company_id
            if(response?.data?.currency){
                dispatch(updateCurrency(response?.data?.currency));
            }
            localStorage.setItem(AUTH_TOKEN, token);
            localStorage.setItem(USER_ID, user_id)
            localStorage.setItem(COMPANY_NAME, company_name)
            localStorage.setItem('website', webSite);
            localStorage.setItem('companyId', company_id);
            dispatch(setAuthStatus(response?.data?.role_id));
            return token;
        } catch (err) {
            console.log("not in catch", err);
            return rejectWithValue("SSO URL Invalid");
        }
    }
);

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        authenticated: (state, action) => {
            state.loading = false;
            state.redirect = "/";
            state.token = action.payload;
        },
        showAuthMessage: (state, action) => {
            state.message = action.payload;
            state.showMessage = true;
            state.loading = false;
        },
        hideAuthMessage: (state) => {
            state.message = "";
            state.showMessage = false;
        },
        signOutSuccess: (state) => {
            state.loading = false;
            state.token = null;
            state.redirect = "/";
        },
        showLoading: (state) => {
            state.loading = true;
        },
        signInSuccess: (state, action) => {
            state.loading = false;
            state.token = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(signIn.pending, (state) => {
                state.loading = true;
            })
            .addCase(signIn.fulfilled, (state, action) => {
                state.loading = false;
                state.redirect = "/app/shoppable-feeds/add-feed";
                state.token = action.payload;
            })
            .addCase(signIn.rejected, (state, action) => {
                state.message = action.payload;
                state.showMessage = true;
                state.loading = false;
            })
            .addCase(signOut.fulfilled, (state) => {
                state.loading = false;
                state.token = null;
                state.redirect = "/";
            })
            .addCase(signOut.rejected, (state) => {
                state.loading = false;
                state.token = null;
                state.redirect = "/";
            })
            .addCase(signUp.pending, (state) => {
                state.loading = true;
            })
            .addCase(signUp.fulfilled, (state, action) => {
                state.loading = false;
                state.redirect = "/auth/login";
                state.token = action.payload;
            })
            .addCase(signUp.rejected, (state, action) => {
                state.message = action.payload;
                state.showMessage = true;
                state.loading = false;
            })
            .addCase(signInWithGoogle.pending, (state) => {
                state.loading = true;
            })
            .addCase(signInWithGoogle.fulfilled, (state, action) => {
                state.loading = false;
                state.redirect = "/";
                state.token = action.payload;
            })
            .addCase(signInWithGoogle.rejected, (state, action) => {
                state.message = action.payload;
                state.showMessage = true;
                state.loading = false;
            })
            .addCase(signInWithFacebook.pending, (state) => {
                state.loading = true;
            })
            .addCase(signInWithFacebook.fulfilled, (state, action) => {
                state.loading = false;
                state.redirect = "/";
                state.token = action.payload;
            })
            .addCase(signInWithFacebook.rejected, (state, action) => {
                state.message = action.payload;
                state.showMessage = true;
                state.loading = false;
            })
            .addCase(signInwithSSO.pending, (state) => {
                state.loading = true;
            })
            .addCase(signInwithSSO.fulfilled, (state, action) => {
                state.loading = false;
                state.redirect = "/";
                state.token = action.payload;
            })
            .addCase(signInwithSSO.rejected, (state, action) => {
                state.message = action.payload;
                state.showMessage = true;
                state.loading = false;
            });
    },
});



export const {
    authenticated,
    showAuthMessage,
    hideAuthMessage,
    signOutSuccess,
    showLoading,
    signInSuccess,
} = authSlice.actions;

export default authSlice.reducer;
